import type { RouteRecordRaw } from "vue-router";

import { CHANNELS, COUNTRIES, type Country } from "@/enums/Countries";
import type { Channel } from "@/enums/Countries";
import { TvRoutes } from "@/enums/routes/TvRoutes.ts";
import TvLayout from "@/layout/app/production/TvLayout.vue";

export function tvRoutes(): RouteRecordRaw[] {
    return [
        {
            path: "/tv",
            component: TvLayout,
            children: [
                {
                    path: `:country(${COUNTRIES.join("|")})/:channel(${CHANNELS.join("|")})/stats`,
                    name: TvRoutes.STATS,
                    component: () => import("../views/tv/TvStats.vue"),
                    props: (route) => ({
                        country: route.params.country as Country,
                        channel: route.params.channel as Channel,
                    }),
                },
            ],
        },
    ];
}
